// App Version Configuration
export const APP_VERSION = {
  version: "2.4.0",
  build: "2026-02-20",
  name: "Dein Gutachten Direkt",
  features: [
    "Partner Portal",
    "Kunden Portal", 
    "Anwalt Portal",
    "Admin Dashboard",
    "Vertrieb Präsentation"
  ]
};

export const getVersionString = () => {
  return `v${APP_VERSION.version} (${APP_VERSION.build})`;
};
